import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=7025d2ed&scoped=true&"
import script from "./createForm.vue?vue&type=script&lang=js&"
export * from "./createForm.vue?vue&type=script&lang=js&"
import style0 from "./createForm.vue?vue&type=style&index=0&id=7025d2ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7025d2ed",
  null
  
)

export default component.exports